<style scoped>
.btn-login {
  font-size: 12px;
  color: #fff !important;
  background-color: #8e8a87 !important;

}
</style>

<template>
  <v-layout justify-end row wrap>
    <v-flex align-self-end v-if="showButtonNewAccount()" xs12 md6 pb-0>
      <v-btn block class="btn-login ma-0"
             :to="{name: 'new-account'}">
        {{
          $vuetify.t('$vuetify.Login.newAccount') |
              uppercase
        }}
      </v-btn>
    </v-flex>

    <v-flex align-self-end v-if="showButtonResetPassword()" xs12 md6 pb-0>
      <v-btn block class="btn-login ma-0"
             :to="{name: 'reset-password'}">
        {{
          $vuetify.t('$vuetify.Login.lostPassword')
              |
              uppercase
        }}
      </v-btn>
    </v-flex>

    <v-flex align-self-end v-if="showButtonLogin()" xs12 md6 pb-0>
      <v-btn block class="btn-login ma-0"
             :to="{name: 'login'}">
        {{
          $vuetify.t('$vuetify.generic.executeLogin')
              |
              uppercase
        }}
      </v-btn>
    </v-flex>

  </v-layout>
</template>

<script>
export default {
  name: "SharedLoginButtons",
  methods: {

    showButtonResetPassword() {
      return this.$router.currentRoute.name === "login" || this.$router.currentRoute.name === "new-account"
    },
    showButtonLogin() {
      return this.$router.currentRoute.name === "new-account" ||
          this.$router.currentRoute.name === "reset-password" ||
          this.$router.currentRoute.name === "new-password"
    },
    showButtonNewAccount() {
      return this.$router.currentRoute.name === "login" ||
          this.$router.currentRoute.name === "reset-password" ||
          this.$router.currentRoute.name === "new-password"

    },
  },
}
</script>

